import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { deviceService } from '../services/deviceService';
import { DeviceType } from '../types';

const { Option } = Select;

interface DeviceTypeSelectorProps {
  value?: number;
  onChange?: (value: number) => void;
  placeholder?: string;
  allowClear?: boolean;
  style?: React.CSSProperties;
  disabled?: boolean;
}

/**
 * 设备类型选择器组件
 * 从后端获取所有设备类型列表供选择
 */
const DeviceTypeSelector: React.FC<DeviceTypeSelectorProps> = ({
  value,
  onChange,
  placeholder = '请选择设备类型',
  allowClear = true,
  style,
  disabled = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [deviceTypes, setDeviceTypes] = useState<DeviceType[]>([]);

  // 加载设备类型列表
  useEffect(() => {
    loadDeviceTypes();
  }, []);

  const loadDeviceTypes = async () => {
    try {
      setLoading(true);
      const response = await deviceService.getAllDeviceTypes();
      if (response.status === 1 && response.data) {
        // 过滤掉已删除的设备类型
        const activeTypes = response.data.filter(type => !type.deleted);
        setDeviceTypes(activeTypes);
      } else {
        console.error('加载设备类型列表失败:', response.msg);
        setDeviceTypes([]);
      }
    } catch (error) {
      console.error('加载设备类型列表失败:', error);
      setDeviceTypes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (selectedValue: number) => {
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      allowClear={allowClear}
      style={style}
      disabled={disabled}
      loading={loading}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        (option?.label as string)
          ?.toLowerCase()
          ?.includes(input.toLowerCase())
      }
      notFoundContent={loading ? <Spin size="small" /> : '暂无数据'}
    >
      {deviceTypes.map(type => (
        <Option key={type.id} value={type.id} label={`${type.name} (${type.firm})`}>
          {type.name} ({type.firm})
        </Option>
      ))}
    </Select>
  );
};

export default DeviceTypeSelector;
